import { render, staticRenderFns } from "./CourseDatabaseManagement.vue?vue&type=template&id=f0f13c54&scoped=true&"
import script from "./CourseDatabaseManagement.vue?vue&type=script&lang=js&"
export * from "./CourseDatabaseManagement.vue?vue&type=script&lang=js&"
import style0 from "./CourseDatabaseManagement.vue?vue&type=style&index=0&id=f0f13c54&lang=less&scoped=true&"
import style1 from "./CourseDatabaseManagement.vue?vue&type=style&index=1&id=f0f13c54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f13c54",
  null
  
)

export default component.exports